module.exports = __webpack_public_path__ + "static/media/bio-h.3f355759.jpeg";